var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.375C21 9.067 16.97 11.25 12 11.25C7.03 11.25 3 9.067 3 6.375C3 3.683 7.03 1.5 12 1.5C16.97 1.5 21 3.683 21 6.375Z",
    fill: "#98A1B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.7501C14.685 12.7501 17.19 12.1641 19.078 11.1411C19.7728 10.7722 20.4116 10.3062 20.975 9.75708C20.991 9.87808 21 10.0011 21 10.1251C21 12.8171 16.97 15.0001 12 15.0001C7.03 15.0001 3 12.8171 3 10.1251C3 10.0011 3.009 9.87808 3.025 9.75708C3.58842 10.3061 4.22716 10.7722 4.922 11.1411C6.809 12.1641 9.315 12.7501 12 12.7501Z",
    fill: "#98A1B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5001C14.685 16.5001 17.19 15.9141 19.078 14.8911C19.7729 14.5222 20.4116 14.0562 20.975 13.5071C20.991 13.6281 21 13.7511 21 13.8751C21 16.5671 16.97 18.7501 12 18.7501C7.03 18.7501 3 16.5671 3 13.8751C3 13.7511 3.009 13.6281 3.025 13.5071C3.58841 14.0561 4.22716 14.5222 4.922 14.8911C6.809 15.9141 9.315 16.5001 12 16.5001Z",
    fill: "#98A1B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.2501C14.685 20.2501 17.19 19.6641 19.078 18.6411C19.7729 18.2722 20.4116 17.8062 20.975 17.2571C20.991 17.3781 21 17.5011 21 17.6251C21 20.3171 16.97 22.5001 12 22.5001C7.03 22.5001 3 20.3171 3 17.6251C3 17.5011 3.009 17.3781 3.025 17.2571C3.58841 17.8061 4.22716 18.2722 4.922 18.6411C6.809 19.6641 9.315 20.2501 12 20.2501Z",
    fill: "#98A1B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.894e3cbe3ed0c848669c2d596363e085.svg";
export { ForwardRef as ReactComponent };